var _module_exports = "<div class=\"lightbox-content dwm-lightbox\">\n    <div class=\"text-center mt50 mb50\">\n        <a class=\"btn-medium btn-primary\" ng-click=\"buy()\">buy</a>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/dwm-upsell/dwm-upsell.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/ngtemplate-loader?relativeTo=/app/!./scripts/controllers/modals/dwm/dwm-upsell/dwm-upsell.html
// module id = DkO2
// module chunks = 0